"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.poller = exports.default = exports.Poller = exports.DEFAULT_POLLER_INTERVAL = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _isFinite2 = _interopRequireDefault(require("lodash/isFinite"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var DEFAULT_POLLER_INTERVAL = 60000;
exports.DEFAULT_POLLER_INTERVAL = DEFAULT_POLLER_INTERVAL;

var Poller = /*#__PURE__*/function () {
  function Poller() {
    (0, _classCallCheck2.default)(this, Poller);
    this.intervalRegistry = [];
    this.TIMER = DEFAULT_POLLER_INTERVAL;
  }

  (0, _createClass2.default)(Poller, [{
    key: "_runCallback",
    value: function _runCallback(registeredCallback) {
      return (0, _isFunction2.default)(registeredCallback) ? registeredCallback() : undefined;
    }
  }, {
    key: "_runAll",
    value: function _runAll() {
      this.intervalRegistry.forEach(this._runCallback);
    }
  }, {
    key: "_beginPolling",
    value: function _beginPolling() {
      var _this = this;

      this.interval = setInterval(function () {
        return _this._runAll();
      }, this.TIMER);
    }
  }, {
    key: "_togglePolling",
    value: function _togglePolling() {
      if (this.intervalRegistry.length && !this.interval) {
        this._beginPolling();
      } else if (this.intervalRegistry.length === 0 && this.interval) {
        this.endPolling();
      }
    }
  }, {
    key: "endPolling",
    value: function endPolling() {
      this.intervalRegistry = [];
      this.interval = clearInterval(this.interval);
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.intervalRegistry.length > 0;
    }
  }, {
    key: "start",
    value: function start(intervalCallback) {
      // Check to see that FN is not already in registry
      if (this.intervalRegistry.indexOf(intervalCallback) === -1 && (0, _isFunction2.default)(intervalCallback)) {
        this.intervalRegistry.push(intervalCallback);

        this._togglePolling();
      }

      return this.isActive();
    }
  }, {
    key: "stop",
    value: function stop(intervalCallbackId) {
      if ((0, _isFunction2.default)(intervalCallbackId)) {
        this.intervalRegistry = this.intervalRegistry.filter(function (cb) {
          return cb !== intervalCallbackId;
        });

        this._togglePolling();
      }

      return this.isActive();
    }
  }, {
    key: "setTimer",
    value: function setTimer(interval) {
      if ((0, _isFinite2.default)(parseInt(interval, 10))) {
        this.TIMER = interval;
      } // If new value is set, restart poller.


      if (!(0, _isUndefined2.default)(this.interval)) {
        clearInterval(this.interval);

        this._beginPolling();
      }

      return this.isActive();
    }
  }]);
  return Poller;
}();

exports.Poller = Poller;
var poller = new Poller();
exports.poller = poller;
var _default = poller;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/poller/Poller.js
// module id = 5166
// module chunks = 9